import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { SAMPLE_UUID } from '@cli-constants/generators.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { toSampleArrayValue } from './to-sample-array-value.js'
export function sampleSchemaFieldValue(field: SchemaField): unknown {
  if (field.type === 'select') {
    if (field.default !== undefined) {
      return field.multiple ? toSampleArrayValue(field.default) : field.default
    }

    if (field.options && field.options.length > 0) {
      const firstValue = field.options[0].value
      return field.multiple ? [firstValue] : firstValue
    }

    const exampleValue = `Example ${field.label ?? field.name}`
    return field.multiple ? [exampleValue] : exampleValue
  }

  if (field.default !== undefined) {
    return field.default
  }

  switch (field.type) {
    case 'boolean':
      return true
    case 'email':
      return 'developer@example.com'
    case 'number':
    case 'decimal':
      return 1
    case 'uuid':
    case 'serial':
      return SAMPLE_UUID
    case 'date':
      return '2026-01-01'
    case 'timestamp':
      return '2026-01-01T00:00:00.000Z'
    case 'time':
      return '09:00'
    case 'image':
    case 'video':
    case 'media':
      return 'media-id'
    case 'gallery':
      return ['media-id']
    case 'icon':
      return 'FileText'
    case 'relationship':
      if (isUserRelationshipTarget(field.relationship)) {
        return field.multiple ? ['user-id'] : 'user-id'
      }
      return field.multiple ? [SAMPLE_UUID] : SAMPLE_UUID
    case 'group':
      if (field.fields && field.fields.length > 0) {
        return Object.fromEntries(
          field.fields
            .filter((nestedField) => nestedField.name && !isLayoutField(nestedField.type))
            .map((nestedField) => [nestedField.name, sampleSchemaFieldValue(nestedField)])
        )
      }
      return {}
    case 'list':
      if (field.fields && field.fields.length > 0) {
        return [
          Object.fromEntries(
            field.fields
              .filter((nestedField) => nestedField.name && !isLayoutField(nestedField.type))
              .map((nestedField) => [nestedField.name, sampleSchemaFieldValue(nestedField)])
          )
        ]
      }
      return ['Example item']
    default:
      return `Example ${field.label ?? field.name}`
  }
}
